"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilityButtonTertiary = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("../button/constants");
var _button = require("../button");
var _constants2 = require("./constants");
var _react2 = require("@emotion/react");
const color = (0, _utils.token)('color.link.neutral-default');
const StyledTertiaryButton = /*#__PURE__*/(0, _base.default)(_button.Button, process.env.NODE_ENV === "production" ? {
  target: "eenejg60"
} : {
  target: "eenejg60",
  label: "StyledTertiaryButton"
})(_ref => {
  let {
    coloredBackground,
    disabled,
    'aria-disabled': ariaDisabled
  } = _ref;
  if (disabled) {
    return {
      color: _constants2.DISABLED_TEXT_COLOR
    };
  }
  if (ariaDisabled) {
    return {
      color: _constants.ARIA_DISABLED_TEXT_COLOR
    };
  }
  return {
    color,
    ':hover': {
      backgroundColor: coloredBackground ? (0, _utils.token)('color.action.utility.adaptive-bg-hover') : (0, _utils.token)('color.action.utility.bg-hover'),
      color
    },
    ':active': {
      backgroundColor: coloredBackground ? (0, _utils.token)('color.action.utility.adaptive-bg-pressed') : (0, _utils.token)('color.action.utility.bg-pressed'),
      color
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const UtilityButtonTertiary = exports.UtilityButtonTertiary = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    ...props
  } = _ref2;
  return (0, _react2.jsx)(StyledTertiaryButton, (0, _extends2.default)({
    variant: _button.ButtonVariant.Tertiary,
    ref: ref
  }, props), children);
});